import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o'; 

export interface Blog {
  image: string;
  title: string;
  category: string;
  color: string;
  time: string;
}

import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  standalone: false,
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.css'
})
export class TestimonialsComponent {
    // OWl Slider
    testimonialOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Blogs
  posts: Blog[] = [
    {
      image: 'assets/images/blogs/post-01.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-02.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-03.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    }
  ];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
}
